export class AnswerInfo {
  public AnswerId: string;
  public AnswerText: string;
}
